<template>
    <v-container fluid>
      <v-card>
        <!-- <h2 class="text-center title">Обучение вождению в г. Каменка</h2> -->
        <p class="text-center text-h6 font-weight-regular pa-3 hidden-xs-only ma-0" v-html="t('about.heroLong')"></p>
        <p class="text-center text-h6 font-weight-bold pa-2 hidden-sm-and-up ma-0">{{ t('about.heroShort') }}</p>
        <v-row class="px-6">
          <v-col sm="8" offset-sm="2" style="text-indent: 2em" class="text-justify">
            <p
              v-for="(paragraph, index) in introParagraphs"
              :key="`intro-${index}`"
              :class="index === introParagraphs.length - 1 ? 'mb-0' : ''"
              v-html="paragraph"
            ></p>
          </v-col>
        </v-row>
        <v-parallax height="300" :src="require('@/assets/car-B-3.jpg')"></v-parallax>
      </v-card>
      <v-card class="my-2">
        <!-- <h3 class="text-center title">Пару слов об автошколе + карта</h3> -->
        <v-row>
          <v-col sm="10" offset-sm="1" class="history" style="text-indent: 2em">
            <v-container class="px-6 pa-sm-0">
              <p
                v-for="(paragraph, index) in historyPreviewParagraphs"
                :key="`preview-${index}`"
                :class="index === historyPreviewParagraphs.length - 1 ? 'text-justify text--secondary mb-0 mb-sm-4' : 'text-justify text--secondary'"
                v-html="paragraph"
              ></p>
            </v-container>
            <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="px-sm-0" style="font-size: 16px">
                <p class="text-justify text--secondary ma-0">
                  {{ t('about.historyTitle') }}
                </p>
                <template v-slot:actions>
                <a class="text-justify my-auto">
                  {{ t('common.readMore') }}
                </a>
                  <v-icon color="primary">$expand</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p v-for="(paragraph, index) in historyParagraphs" :key="`history-${index}`" class="text-justify text--secondary">{{ paragraph }}</p>
              </v-expansion-panel-content>

            </v-expansion-panel>
            </v-expansion-panels>


          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
      <v-card class="my-2">
        <h2 class="text-center title">{{ t('about.categoriesTitle') }}</h2>
        <v-row>
          <v-col md="8" offset-md="2">
            <v-card outlined>
              <v-data-table
                :headers="categoriesHeaders"
                :items="categories"
                hide-default-footer
                disable-sort
              >
                <template #item.cars="{ item }">
                    <v-btn fab text @click="$vuetify.goTo('.v-tabs'); tab = item.cars">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                    <!-- <router-link to="/fuck">Посмотреть</router-link> -->
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <h2 class="text-center title">{{ t('about.fleetTitle') }}</h2>
        <v-tabs centered show-arrows center-active icons-and-text v-model="tab" color="green darken-3">
          <v-tab>{{ t('nav.categoryA') }}<v-icon>mdi-bike</v-icon></v-tab>
          <v-tab>{{ t('nav.categoryB') }}<v-icon>mdi-car</v-icon></v-tab>
          <v-tab>{{ t('nav.categoryC') }}<v-icon>mdi-truck</v-icon></v-tab>
          <v-tab>{{ t('nav.categoryD') }}<v-icon>mdi-bus-side</v-icon></v-tab>
          <v-tab>{{ t('nav.categoryE') }}<v-icon>mdi-truck-trailer</v-icon></v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(tabContent, index) in tabsContent" :key="index">
            <v-card flat>
              <v-row class="text-center" no-gutters>
                <v-col cols="12" sm="6" class="pa-2">
                  <!-- <v-card class="ma-3"> -->
                    <v-container class="py-0">
                      <h3>{{ t('about.vehicleTitle') }}</h3>
                      <!-- <v-img src="https://picsum.photos/400/200?random"></v-img> -->
                      <!-- <Carousel :items="masters" :sliderItemsBreakpoints="{cols: 12}" aspectRatio="2.5"></Carousel> -->
                      <!-- <CarouselOrItem v-if="1" :items="[]" :sliderItemsBreakpoints="{cols: 12}" aspectRatio="2"></CarouselOrItem> -->
                      <!-- <CarouselOrItem v-if="1" :items="masters.slice(0, 1)" :sliderItemsBreakpoints="{cols: 12}" aspectRatio="2"></CarouselOrItem> -->
                      <CarouselOrItem :items="tabContent.cars" :sliderItemsBreakpoints="{cols: 12}" aspectRatio="2"></CarouselOrItem>
                    </v-container>
                  <!-- </v-card> -->
                </v-col>
                <v-col cols="12" sm="6" class="pa-2">
                  <v-container class="py-0">
                    <h3>{{ t('about.platformTitle') }}</h3>
                    <!-- <v-img src="https://picsum.photos/400/200?random"></v-img> -->
                    <CarouselOrItem :items="tabContent.platform" :sliderItemsBreakpoints="{cols: 12}" aspectRatio="2"></CarouselOrItem>
                  </v-container>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-divider></v-divider>
        <!-- <v-divider></v-divider> -->
        <!-- <h2 class="text-center title">Необходимые документы</h2> -->
        <!-- <v-divider></v-divider> -->
        
        <v-container>
          <!-- <v-carousel cycle height="100%" hide-delimiter-background hide-delimiters>
            <v-carousel-item v-for="index in arr(amountSliderPages)" :key="index">
              <v-sheet id="masters" light height="100%">
                <v-row justify="center" align="center" class="fill-height">
                  <v-col v-bind="sliderItemsBreakpoints" v-for="ind in arr(Math.min(itemsPerSlide, masters.length - index * itemsPerSlide))" :key="ind">
                    <v-card class="text-center">
                      <v-img :src="masters[index * itemsPerSlide + ind].photo" aspect-ratio="1"></v-img>
                      <v-card-title class="text-subtitle-1 font-weight-bold justify-center">{{ masters[index * itemsPerSlide + ind].name }}</v-card-title>
                      <v-card-subtitle>{{ masters[index * itemsPerSlide + ind].exp }}</v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel> -->
          <v-row class="justify-center">
            <v-col cols="12" class="py-0">
              <h2 class="text-center title">{{ t('about.mastersTitle') }}</h2>
              <CarouselOrItem :items="masters" :sliderItemsBreakpoints="sliderItemsBreakpoints" :aspectRatio="1" imageStyle="max-height: 250px" :avatar="true"></CarouselOrItem>
            </v-col>
            <v-col md="6" class="py-0">
              <h2 class="text-center title">{{ t('about.teachersTitle') }}</h2>
              <CarouselOrItem :items="teachers" :sliderItemsBreakpoints="miniSliderItemsBreakpoints" :aspectRatio="1" imageStyle="max-height: 250px" :avatar="true"></CarouselOrItem>
            </v-col>
            <v-col md="6" class="py-0">
              <h2 class="text-center title">{{ t('about.directorTitle') }}</h2>
              <CarouselOrItem :items="bosses" :sliderItemsBreakpoints="miniSliderItemsBreakpoints" :aspectRatio="1" imageStyle="max-height: 250px" :avatar="true"></CarouselOrItem>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <h2 class="text-center title">{{ t('about.contactsTitle') }}</h2>
        <v-row class="text-center" no-gutters>
          <v-col cols="12" md="6" order="1" order-md="1">
            <!-- <v-card> -->
              <h3 class="font-weight-light">{{ t('about.contactDetailsTitle') }}</h3>
          </v-col>
          <v-col cols="12" md="6" order="3" order-md="2">
            <h3 class="font-weight-light">{{ t('about.mapTitle') }}</h3>
          </v-col>
          <v-col cols="12" md="6" order="2" order-md="3">
              <v-container fill-height>
                <v-sheet align="center" class="mx-auto">
                  <p>
                    <v-icon>mdi-map-marker</v-icon>{{ t('about.addressLabel') }}
                  </p>

                  <p class="font-weight-bold">
                    {{ t('about.address') }}
                  </p>

                  <p>
                    <v-icon>mdi-clock-outline</v-icon> <span class="font-weight-bold">{{ t('about.workHoursLabel') }}</span> {{ t('about.workHours') }}
                  </p>

                  <p>
                    <v-icon>mdi-coffee</v-icon> <span class="font-weight-bold">{{ t('about.breakLabel') }}</span> {{ t('about.breakHours') }}
                  </p>

                  <p>
                    <v-icon>mdi-phone</v-icon> <strong>{{ t('about.phoneLabel') }}</strong> <a href="tel:+7(84156)5-19-61">+7(84156)5-19-61</a>; 5-17-04 
                  </p>

                  <p>
                    <v-icon>mdi-email</v-icon> <strong>{{ t('about.emailLabel') }}</strong> <a href="mailto:kamdosaaf58@mail.ru">kamdosaaf58@mail.ru</a>
                  </p>
                </v-sheet>
              </v-container>
            <!-- </v-card> -->
          </v-col>
          <v-col cols="12" md="6" order="4" order-md="4">
            <!-- <v-card outlined> -->
              
              <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A07d926d381a640cd4f2827381fbc7669f618208d5f8a112ac4932ee24d5ed022&amp;source=constructor" width="100%" height="100%" frameborder="0" style="min-height: 350px"></iframe>
              <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1195.7093209662328!2d44.03863435814718!3d53.17446970265001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4140c086bf590021%3A0xc6db75d60e56375d!2z0L_QtdGALiDQmtCw0LvQuNC90LjQvdCwLCA00LAsINCa0LDQvNC10L3QutCwLCDQn9C10L3Qt9C10L3RgdC60LDRjyDQvtCx0LsuLCA0NDIyNDE!5e0!3m2!1sru!2sru!4v1597523320245!5m2!1sru!2sru" width="100%" height="100%" frameborder="0" style="border:0; min-height: 350px" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
            <!-- </v-card> -->
          </v-col>
        </v-row>
      </v-card>
    </v-container>
</template>

<script>
// import Carousel from '../components/Carousel';
import { db, firebaseEnabled } from '@/fb'
import CarouselOrItem from '../components/CarouselOrItem'

export default {
    name: 'About',
    components: {
      CarouselOrItem
    },
    beforeRouteEnter(to, from, next) {
      void from
      if (to.hash) {
        next(vm => {
          if (to.hash.slice(1).split('-').shift() === 'category') {
            vm.tab = ['A', 'B', 'C', 'D', 'E'].indexOf(to.hash.slice(1).split('-').pop())
            vm.$vuetify.goTo('.v-tabs')
          }
          // vm.expandedPanels[vm.ACTIVE_DOC_INDEX] = 0
        })
      } else next()
    },
    async created() {
        if (!firebaseEnabled || !db) {
          return
        }

        try {
          const gotData = (await db.collection('categories').orderBy('index').get()).docs.map(doc => doc.data())
          if (gotData.length > 0) this.categoriesFromDb = gotData
        } catch (error) {
          console.error(error)
          this.categoriesFromDb = []
        }
    },
    computed: {
      aboutContent() {
        return (this.$i18n.messages[this.currentLocale] || this.$i18n.messages.tr).about
      },
      introParagraphs() {
        return this.aboutContent.introParagraphs.map(paragraph => this.interpolateText(paragraph))
      },
      historyPreviewParagraphs() {
        return this.aboutContent.historyPreviewParagraphs.map(paragraph => this.interpolateText(paragraph, {
          years: new Date().getFullYear() - 1955
        }))
      },
      historyParagraphs() {
        return this.aboutContent.historyParagraphs.map(paragraph => this.interpolateText(paragraph))
      },
      itemsPerSlide() {
        return Math.floor(12 / this.sliderItemsBreakpoints[{"xs": "cols"}[this.$vuetify.breakpoint.name]||this.$vuetify.breakpoint.name])
      },
      amountSliderPages() {
        return Math.ceil(this.masters.length / this.itemsPerSlide)
      },
      masters() {
        return this.mastersBase.map(person => ({
          name: person.name,
          exp: this.t('about.peopleExperience', { years: new Date().getFullYear() - person.startYear }),
          photo: person.photo
        }))
      },
      teachers() {
        return this.teachersBase.map(person => ({
          name: person.name,
          exp: this.t('about.peopleExperience', { years: new Date().getFullYear() - person.startYear }),
          photo: person.photo
        }))
      },
      bosses() {
        return this.bossesBase.map(person => ({
          name: person.name,
          exp: this.t('about.peopleExperience', { years: new Date().getFullYear() - person.startYear }),
          photo: person.photo
        }))
      },
      categoriesHeaders() {
        return [
          { text: this.t('about.categoryHeaders.category'), value: 'category', align: 'center' },
          { text: this.t('about.categoryHeaders.price'), value: 'price', align: 'center' },
          { text: this.t('about.categoryHeaders.cars'), value: 'cars', align: 'center' },
          // { text: "Площадки", value: 'cars', align: 'center' },
          { text: this.t('about.categoryHeaders.docs'), value: 'docs', align: 'center' },
        ]
      },
      categories() {
        if (this.categoriesFromDb.length > 0) {
          return this.categoriesFromDb.map(category => {
            const baseCategory = this.categoriesBase.find(item => item.category === category.category)

            if (!baseCategory) {
              return category
            }

            return {
              ...category,
              docs: this.composeCategoryDocs(baseCategory)
            }
          })
        }

        return this.categoriesBase.map(category => ({
          category: category.category,
          price: category.price,
          cars: category.cars,
          docs: this.composeCategoryDocs(category)
        }))
      }
    },
    methods: {
      arr: function(len) {
        return [...Array(len).keys()]
      },
      interpolateText(text, params = {}) {
        return text.replace(/\{(\w+)\}/g, (match, key) => {
          if (params[key] === undefined || params[key] === null) {
            return match
          }

          return params[key]
        })
      },
      composeCategoryDocs(category) {
        const baseKey = category.docsType === 'license' ? 'about.requiredDocsLicense' : 'about.requiredDocsBase'
        const details = [this.t(baseKey)]

        if (category.extraRequirementKey) {
          details.push(this.t(`about.${category.extraRequirementKey}`))
        }

        return details.join(', ')
      }
    },
    data: () => ({
      tab: 1,
      categoriesFromDb: [],
      mastersBase: [
        {
          name: "Панькин Владимир Александрович",
          startYear: 1983,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Серов Николай Николаевич",
          startYear: 2008,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Корытцев Александр Васильевич",
          startYear: 2010,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Кондрахин Олег Владимирович",
          startYear: 2013,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Мезенцев Михаил Юрьевич",
          startYear: 2013,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Сенаторов Александр Михайлович",
          startYear: 2006,
          photo: require('@/assets/userImage.png')
        },
      ],
      teachersBase: [
        {
          name: "Шиманский Александр Богданович",
          startYear: 1998,
          photo: require('@/assets/userImage.png')
        },
        {
          name: "Волков Виктор Иванович",
          startYear: 2006,
          photo: require('@/assets/userImage.png')
        },
      ],
      bossesBase: [
        {
          name: "Афонькин Юрий Леонидович",
          startYear: 2006,
          photo: require('@/assets/userImage.png')
        },
      ],
      tabsContent: [
        { category: 'A', cars: [
            { photo: require('@/assets/car-A.jpg') },
            { photo: require('@/assets/car-A-1.jpg') },
          ], platform: [
            { photo: require('@/assets/platform-A.jpg') },
          ] },
        { category: 'B', cars: [
            { photo: require('@/assets/car-B.jpg') },
            { photo: require('@/assets/car-B-1.jpg') },
            { photo: require('@/assets/car-B-2.jpg') },
            { photo: require('@/assets/car-B-3.jpg') },
          ], platform: [
            { photo: require('@/assets/platform-B.jpg') },
            { photo: require('@/assets/platform-B-1.jpg') },
            { photo: require('@/assets/platform-B-2.jpg') },
            { photo: require('@/assets/platform-B-3.jpg') },
          ] },
        { category: 'C', cars: [
            { photo: require('@/assets/car-C.jpg') },
            { photo: require('@/assets/car-C-1.jpg') },
            { photo: require('@/assets/car-C-2.jpg') },
          ], platform: [
            { photo: require('@/assets/platform-C.jpg') },
          ] },
        { category: 'D', cars: [
            { photo: require('@/assets/car-D.jpg') },
          ], platform: [
            { photo: require('@/assets/platform-C.jpg') },
          ] },
        { category: 'E', cars: [
            { photo: require('@/assets/car-E.jpg') },
            { photo: require('@/assets/car-E-1.jpg') },
            { photo: require('@/assets/car-E-2.jpg') },
          ], platform: [
            { photo: require('@/assets/platform-C.jpg') },
          ] },
      ],
      sliderItemsBreakpoints: {
        xl: 2, lg: 3, md: 4, sm: 6, cols: 12
      },
      miniSliderItemsBreakpoints: {
        xl: 4, lg: 6, md: 12, sm: 12, cols: 12
      },
      categoriesBase: [
        { category: "A", price: "7000", cars: 0, docsType: 'base' },
        { category: "B", price: "13000", cars: 1, docsType: 'base' },
        { category: "C", price: "15000", cars: 2, docsType: 'base' },
        { category: "BC", price: "25000", cars: 2, docsType: 'base' },
        { category: "CE", price: "15000", cars: 4, docsType: 'license', extraRequirementKey: 'requirementMinExperience' },
        { category: "C → D", price: "20000", cars: 3, docsType: 'license', extraRequirementKey: 'requirementAge21' },
      ]
    })
}
</script>
